import { call, put, takeEvery } from 'redux-saga/effects';
import { SalesAdminActionKeys, SaveNegotiatingTactic } from '..';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { INegotiatingTactic, lookupActionCreators } from '../../lookups';
import { showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import { saveNegotiatingTactic } from '../salesAdminApi';

function* saveNegotiatingTacticSaga(action: SaveNegotiatingTactic) {
  yield put(uiActionCreators.showSpinnerDialog());

  const response: IApiExecuteRespone<INegotiatingTactic> = yield call(saveNegotiatingTactic, action.payload);

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else if (response.value) {
    yield put(lookupActionCreators.setLookups({ partial: true, payload: { negotiatingTactics: [response.value] } }));
  }

  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchSaveNegotiatingTactic() {
  yield takeEvery(SalesAdminActionKeys.SAVE_NEGOTIATING_TACTIC, saveNegotiatingTacticSaga);
}
